import messages from '../../../../locale/messages';

const validate = values => {

  const errors = {}

  if (!values.aboutUsTitle) {
    errors.aboutUsTitle = messages.required;
  } else if (values.aboutUsTitle.trim() == "") {
    errors.aboutUsTitle = messages.required;
  } else if (values.aboutUsTitle && values.aboutUsTitle.length > 200) {
    errors.aboutUsTitle = messages.exceedLimit;
  }

  if (!values.aboutUsContent) {
    errors.aboutUsContent = messages.required;
  } else if (values.aboutUsContent.trim() == "") {
    errors.aboutUsContent = messages.required;
  } else if (values.aboutUsContent && values.aboutUsContent.length > 400) {
    errors.aboutUsContent = messages.exceedLimit;
  }


  return errors
}

export default validate;